import React from 'react';
import cn from 'classnames';
import isBoolean from 'lodash/isBoolean';
import styles from './checkCellCallback.module.scss';
import IconSuccess from '@dealroadshow/uikit-icon/IconSuccess';

interface IProps {
  cellData: boolean | string | React.ReactElement,
  className?: string,
  dataTest?: string,
}

const CheckCellCallback = ({
  cellData,
  className,
  dataTest,
}: IProps) => (isBoolean(cellData) ? (
  <IconSuccess
    className={ cn({
      [styles.iconCheckActive]: !!cellData,
      [styles.iconCheckInActive]: !cellData,
    }, className) }
    data-test={ dataTest }
  />
) : cellData);

export default CheckCellCallback;
